import React, {useState} from "react";
import {connect} from "react-redux";
import {Button, DateInput, fetchEnd, fetchStart, refreshView, SaveButton, SimpleForm,} from "react-admin";
import {compose} from "redux";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import IconCancel from "@material-ui/icons/Cancel";
import {change, isSubmitting, submit} from "redux-form";
import axiosInstance from "../../api/axios";
import {showErrorNotify, showSuccessNotify, showWarningNotify,} from "../../components";
import moment from "moment";

const styles = {
    suggestDialog: {
        zIndex: "1 !important",
    },
    width100: {
        width: "100%",
    },
};

const EditDueDateBtn = ({
                         record,
                         submit,
                         isSubmitting,
                         classes, format
                     }) => {
    const [dueDate, setDueDate] = useState(record.dueDate);
    const [showDialog, setShowDialog] = useState(false);

    const handleClick = (e) => {
        e.stopPropagation();
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSaveClick = () => {
        submit("dueDate-quick-create");
    };

    const handleSubmit = (values) => {
        const url = `/api/billBatch/changeDueDate?id=${record.id}&dueDate=${values.dueDate}`;
        axiosInstance
            .put(url)
            .then((res) => {
                if (res.data && res.data.success) {
                    setDueDate(values.dueDate)
                    showSuccessNotify("Đã cập ngày đến hạn");
                    handleCloseClick();
                } else {
                    showWarningNotify("Cập nhật ngày đến hạn không thành công.");
                }
            })
            .catch((err) => {
                console.error(err);
                showErrorNotify(
                    "Có lỗi xảy ra, vui lòng thử lại hoặc liên hệ quản trị viên"
                );
            });
    }

    return (
        <div>
            <Button color="primary" onClick={handleClick} label={moment(dueDate).format(format)} />
            <Dialog
                className={classes.suggestDialog}
                fullWidth
                maxWidth="sm"
                open={showDialog}
                onClose={handleCloseClick}
            >
                <DialogTitle>Nhập ngày đến hạn</DialogTitle>
                <DialogContent>
                    <SimpleForm form="dueDate-quick-create" onSubmit={handleSubmit} toolbar={null}>
                        <DateInput source='dueDate'
                                   defaultValue={dueDate}
                                   label="resources.billBatches.fields.dueDate"
                        />
                    </SimpleForm>
                </DialogContent>
                <DialogActions>
                    <SaveButton saving={isSubmitting} onClick={handleSaveClick}/>
                    <Button label="ra.action.cancel" onClick={handleCloseClick}>
                        <IconCancel/>
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

const mapStateToProps = (state) => ({
    isSubmitting: isSubmitting("dueDate-quick-create")(state),
});

const mapDispatchToProps = {
    change,
    fetchEnd,
    fetchStart,
    submit,
    refreshView,
};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles)
)(EditDueDateBtn);
